// ----------------------------------------------------------------------
export function radio(theme) {
    return {
        // CHECKBOX, RADIO, SWITCH
        MuiFormControlLabel: {
            styleOverrides: {
                label: Object.assign({}, theme.typography.body2)
            }
        },
        MuiRadio: {
            styleOverrides: {
                root: {
                    padding: theme.spacing(1)
                }
            }
        }
    };
}
